export default "__VITE_ASSET__3Qkkwk1H__"